var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useDrawer } from 'context/DrawerContext';
import sharedMessages from 'translations/shared';
import { track, SegmentTrackableEnum } from 'factory/SegmentFactory';
import createWebinarMutation from './createWebinar.graphql';
import createWebinarSessionMutation from './createWebinarSession.graphql';
import View from './View';
var Container = function (props) {
    var onError = props.onError, onSuccess = props.onSuccess;
    var closeDrawer = useDrawer().closeDrawer;
    var _a = __read(useState(), 2), onCreateState = _a[0], setOnCreateState = _a[1];
    var _b = __read(useState(), 2), onCreateSessionState = _b[0], setOnCreateSessionState = _b[1];
    var formatMessage = useIntl().formatMessage;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _c = __read(useMutation(createWebinarSessionMutation, {
        onCompleted: function (data) {
            if (onSuccess)
                onSuccess(data.addWebinarSession);
            enqueueSnackbar(formatMessage(sharedMessages.addedWebinar), {
                variant: 'success',
            });
        },
        onError: function (error) {
            enqueueSnackbar(error.message, { variant: 'error' });
            if (onError)
                onError(error);
        },
    }), 2), createWebinarSession = _c[0], createSessionResult = _c[1];
    var onCreateSession = function (input) {
        createWebinarSession({
            variables: {
                input: input,
            },
        });
    };
    var _d = __read(useMutation(createWebinarMutation, {
        onCompleted: function (data) {
            if (onSuccess)
                onSuccess(data.addWebinar);
            track(SegmentTrackableEnum.WEBINAR_CREATED, __assign({}, data));
            closeDrawer();
            if (!onCreateSessionState)
                return;
            var createSession = __assign(__assign({}, onCreateSessionState), { webinarId: data.createWebinar.id });
            onCreateSession(createSession);
        },
        onError: function (error) {
            enqueueSnackbar(error.message, { variant: 'error' });
            if (onError)
                onError(error);
        },
    }), 2), createWebinar = _d[0], createResult = _d[1];
    var onCreate = function (input) {
        createWebinar({
            variables: {
                input: input,
            },
        });
    };
    useEffect(function () {
        if (!onCreateState)
            return;
        onCreate(onCreateState);
    }, [onCreateState]);
    return (_jsx(View, { onCreateState: setOnCreateState, onCreateSessionState: setOnCreateSessionState, error: createResult.error, isProcessing: createResult.loading }, void 0));
};
export default Container;
